<template lang="pug">
  .content
    .content__block
      .content-default-margin
        p.content-schedule(
        v-for="item in shceduleItems"
        )
          span  {{item[0]}} {{item[1]}}
</template>

<script>

export default {
  name: "ShiftSchedule",
  props: {
    schedule: {
      type: String,
      default: ""
    }
  },
  computed: {
    shceduleItems() {
      let arr = this.schedule.split(";");
      arr = arr.map(item => {
        item = item.split("&");
        return item;
      });
      return arr;
    }
  }

};
</script>
